// extracted by mini-css-extract-plugin
export default {"button":"Button_button__g8Fa0","disable":"Button_disable__F2Yq4"};